import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { useRemoveAnalysisFromDashboard } from '@modules/dashboard/hooks';
import { EditableDashboard } from '@modules/dashboard/types';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';

interface RemoveAnalysisDialogContentProps {
  dashboard: EditableDashboard;
  analysis: AnalysisViewFragment;
}

export const RemoveAnalysisDialogContent = ({
  dashboard,
  analysis,
}: RemoveAnalysisDialogContentProps) => {
  const { closeModal } = useMuiModalContext();

  const onClose = () => closeModal();

  const { removeAnalysis, loading } = useRemoveAnalysisFromDashboard();

  const handleRemoveAnalysis = async () => {
    await removeAnalysis({
      dashboard,
      analysis,
    });

    closeModal();
  };

  return (
    <>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6">Remove Quantify from Dashboard?</Typography>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to remove this Quantify from the Dashboard?
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Stack direction="row" m={1} spacing={2}>
          <Button onClick={onClose} variant="outlined">
            No, keep it
          </Button>
          <LoadingButton
            loading={loading}
            onClick={handleRemoveAnalysis}
            variant="contained"
            color="error"
            autoFocus
          >
            Remove
          </LoadingButton>
        </Stack>
      </DialogActions>
    </>
  );
};
